import { useEffect, useState } from "react";
import { History, ChevronDown } from "lucide-react";
import { http, DOMAIN_SHORT } from "@/lib/api";

const verdictColor = (v) => ({ Excellent: "var(--ok)", Pass: "var(--ok)", Borderline: "var(--warn)" }[v] || "var(--alert)");
const when = (iso) => new Date(iso).toLocaleString("en-AU", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });

const Item = ({ a, i }) => {
  const [open, setOpen] = useState(false);
  return (
    <li data-testid={`driving-recent-item-${i}`} className="card p-4">
      <button data-testid={`driving-recent-toggle-${i}`} onClick={() => setOpen((o) => !o)} className="w-full text-left flex items-start gap-3">
        <div className="flex-1 min-w-0">
          <p className="text-xs font-mono" style={{ color: "var(--ink-3)" }}>{when(a.created_at)} · D{a.domain} {DOMAIN_SHORT[a.domain - 1]}</p>
          <p className={`mt-1 text-sm font-medium ${open ? "" : "line-clamp-2"}`}>{a.question}</p>
        </div>
        <span className="font-mono text-sm font-bold shrink-0" style={{ color: verdictColor(a.verdict) }}>{a.score}/10</span>
        <ChevronDown size={16} className={`shrink-0 mt-0.5 transition-transform ${open ? "rotate-180" : ""}`} style={{ color: "var(--ink-3)" }} />
      </button>
      {open && (
        <div data-testid={`driving-recent-detail-${i}`} className="mt-3 space-y-2 text-xs" style={{ color: "var(--ink-2)" }}>
          <p>{a.spoken_feedback}</p>
          <p className="italic" style={{ color: "var(--ink-3)" }}>You said: {a.transcript || "(nothing heard)"}</p>
          {a.missed_must_say?.length > 0 && <p style={{ color: "var(--warn)" }}>Missed: {a.missed_must_say.join("; ")}</p>}
          <details><summary className="cursor-pointer" style={{ color: "var(--ok)" }}>All must-say points</summary><p className="mt-1">{a.must_say?.join("; ")}</p></details>
        </div>
      )}
    </li>
  );
};

export const DrivingRecent = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { http.get("/driving/attempts").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <section data-testid="driving-recent" className="mt-12">
      <h2 className="font-display text-base md:text-lg font-semibold flex items-center gap-2"><History size={17} style={{ color: "var(--accent)" }} /> Recent attempts</h2>
      {items === null ? null : items.length === 0 ? (
        <p data-testid="driving-recent-empty" className="mt-2 text-sm" style={{ color: "var(--ink-3)" }}>No driving questions answered yet. Your answers and feedback will appear here.</p>
      ) : (
        <ul className="mt-3 space-y-2">{items.map((a, i) => <Item key={a.id} a={a} i={i} />)}</ul>
      )}
    </section>
  );
};
